var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandIconClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.69,21.13H4.32a1.45,1.45,0,0,1-1.44-1.44V4.32A1.45,1.45,0,0,1,4.32,2.88H19.69a1.45,1.45,0,0,1,1.44,1.44V19.69A1.45,1.45,0,0,1,19.69,21.13ZM4.32,3.88a.44.44,0,0,0-.44.44V19.69a.44.44,0,0,0,.44.44H19.69a.44.44,0,0,0,.44-.44V4.32a.44.44,0,0,0-.44-.44Z",
    style: {
      fill: "#caccd0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.18,11.43v1.15h-2.6v2.6H11.43v-2.6H8.83V11.43h2.6V8.83h1.15v2.6Z",
    style: {
      fill: "#caccd0"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconClosed);
export default __webpack_public_path__ + "static/media/expand_icon_closed.5e2605c9ca16613aa4425cb0967bc92c.svg";
export { ForwardRef as ReactComponent };